import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../..";
class ApiEpInstagramUsers {
}
ApiEpInstagramUsers.list = ({ username, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/instagram/users`,
    method: "GET",
    query: {
        username,
    },
});
class ApiEpInstagramProfile {
}
ApiEpInstagramProfile.privacyGet = ({ pageConfigAccountId, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/instagram/${pageConfigAccountId}/profile/privacy`,
    method: "GET",
});
ApiEpInstagramProfile.privacyPost = ({ isPrivate, pageConfigAccountId, pageConfigId, }) => apiRequest({
    body: { is_private: isPrivate, page_config_id: pageConfigId },
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/instagram/${pageConfigAccountId}/profile/privacy`,
    method: "POST",
});
class ApiEpInstagramPost {
}
/**
 * Used to get posts list from instagram (easy way to save our database health)
 */
ApiEpInstagramPost.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/instagram/${req.path.id}/posts`,
    method: "GET",
});
export class ApiEpInstagram {
}
ApiEpInstagram.users = ApiEpInstagramUsers;
ApiEpInstagram.profile = ApiEpInstagramProfile;
ApiEpInstagram.post = ApiEpInstagramPost;
//# sourceMappingURL=instagram.js.map